import React, { useState, useEffect } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    useNotify,
    useRedirect,
    SelectArrayInput,
    BooleanInput,
    useCreate,
    DateField
} from 'react-admin';

export const ModelSchemaEdit = () => {
    return (
        <Edit>
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <TextInput name="modelSchema" source="modelSchema" fullWidth validate={[required()]} multiline  rows={24}/>
                <div>
                    <span style={ { marginRight: '15px' } }>{ "Created At:" }</span>
                    <DateField source="createdAt" />
                </div>
                <div>
                    <span style={ { marginRight: '15px' } }>{ "Updated At:" }</span>
                    <DateField source="updatedAt" />
                </div>
            </SimpleForm>
        </Edit>
    );
}